import React, { lazy, Suspense, useEffect } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { theme } from '../../config/style'
import AppleCallback from '../../containers/AuthorizePage/AppleCallback'
import LineCallback from '../../containers/AuthorizePage/LineCallback'
import { clearSession } from '../../contexts/Auth'
import { LoadingProvider } from '../../contexts/LoadingContext'
import MixpanelTracker from '../../services/track/mixpanel'
import AffiliateCodeCapture from '../AffiliateCodeCapture'
import AuthenticatedPage from '../AuthenticatedPage'
import CarWithDriverSubmissionPage from '../CarWithDriverSubmission/CarWithDriverSubmissionPage'
import ExpertSubmissionPage from '../ExpertSubmission/ExpertSubmissionPage'
import PropertySubmissionPage from '../PropertySubmission/PropertySubmissionPage'
import { HaupLoading } from '../HaupLoading'

const AutoLogin = lazy(() => import('../../containers/AuthorizePage/AutoLogin'))
const LoginPage = lazy(() => import('../../containers/LoginPage'))
const SellTeslaPage = lazy(() => import('../../containers/SellTeslaPage'))
const NewVehicleSubmissionPage = lazy(() => import('../../containers/VehicleSubmissionPage'))
const PaymentCallbackPage = lazy(() => import('../../containers/PaymentCallbackPage'))
const ShareCarPage = lazy(() => import('../../containers/ShareCarPage'))
const ShareCarSuccessPage = lazy(() => import('../../containers/ShareCarPage/SuccessPage'))
const ShareCarStatusPage = lazy(() => import('../../containers/ShareCarPage/StatusPage'))
const Logout = () => {
  MixpanelTracker.reset()
  useEffect(() => {
    clearSession()
    window.location.href = '/'
  }, [])
  return <>Logging Out...</>
}

const submissionPath = '/submission'
const RedirectToSubmission = () => <Redirect to={submissionPath} />

class Router extends React.Component {
  render(): JSX.Element {
    return (
      <LoadingProvider>
        <Suspense fallback={<HaupLoading loading={true} backgroundColor={theme.haupBlue} />}>
          <AffiliateCodeCapture />
          <Switch>
            <Route exact path="/login">
              <LoginPage />
            </Route>
            <Route exact path="/sell-tesla">
              <SellTeslaPage />
            </Route>
            <Route exact path="/auth/apple/callback" component={AppleCallback} />
            <Route exact path="/auth/line/callback" component={LineCallback} />
            <Route exact path="/login/token/:token" component={AutoLogin} />
            <Route exact path="/register/token/:token" component={AutoLogin} />
            <Route exact path="/logout">
              <Logout />
            </Route>
            <Route exact path={'/share-car/:id/status'}>
              <ShareCarStatusPage />
            </Route>
            <Route exact path={'/share-car/:id/success'}>
              <AuthenticatedPage>
                <ShareCarSuccessPage />
              </AuthenticatedPage>
            </Route>
            <Route exact path={'/share-car'}>
              <AuthenticatedPage>
                <ShareCarPage />
              </AuthenticatedPage>
            </Route>
            <Route exact path={'/submission/payment/callback/:paymentLink'}>
              <PaymentCallbackPage />
            </Route>
            <Route exact path={'/submission'}>
              <AuthenticatedPage>
                <NewVehicleSubmissionPage />
              </AuthenticatedPage>
            </Route>
            <Route exact path={'/submission/:recordId'}>
              <AuthenticatedPage>
                <NewVehicleSubmissionPage />
              </AuthenticatedPage>
            </Route>
            <Route exact path={'/submission/:recordId/:pagePath'}>
              <AuthenticatedPage>
                <NewVehicleSubmissionPage />
              </AuthenticatedPage>
            </Route>
            <Route path="/car-with-driver-submission/:step?">
              <AuthenticatedPage>
                <CarWithDriverSubmissionPage />
              </AuthenticatedPage>
            </Route>
            <Route path="/expert-submission/:step?">
              <AuthenticatedPage>
                <ExpertSubmissionPage />
              </AuthenticatedPage>
            </Route>
            <Route path="/property-submission/:step?">
              <AuthenticatedPage>
                <PropertySubmissionPage />
              </AuthenticatedPage>
            </Route>
            <Route path="/">
              <RedirectToSubmission />
            </Route>
          </Switch>
        </Suspense>
      </LoadingProvider>
    )
  }
}

export default Router
